import React from 'react';
import { Accordion} from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import { Table } from 'react-bootstrap';

function TournoisAffichageInscritJoueur(props) {


  return (
    <>
    <Accordion defaultActiveKey="0">
    {props.tournoisInscrit && props.tournoisInscrit.map((item,index) => (
                        <Accordion.Item key={index}  eventKey={`inscrit-${index}`}>
                            <Accordion.Header>
                                    <div>
                                      <strong>{item.nomTournois} - {item.categorie}</strong>
                                      <hr/>
                                      Lieu : <strong>{item.localisation}</strong>
                                      <br/>
                                      Date du tournoi : <strong>{item.date}</strong>
                                      <br/>
                                      Nombres de participants : <strong>{item.nombre_participants} / {item.nbr_equipe} </strong>
                                    </div>
                            </Accordion.Header>
                            <Accordion.Body>
                            <div className="nom" style={{fontSize:"15px",fontWeight:'initial'}}>
                                           Tournois organisé par <a  href={`/coach/equipe/${item.id_equipe}`} target="_blank" rel="noopener noreferrer"><span style={{textTransform : 'capitalize'}}>{item.nom}</span></a> ({item.categorie})
                                           <br/>
                                           {item.nombre_participants === item.nbr_equipe && <strong>Tournoi Complet</strong>}
                                           <br/>
                                           Le status du tournois : {item.status}
                            </div> 
                            <br/>
                            <Form.Label>Commentaire de l'équipe organisatrice</Form.Label>
                            <Form.Control as="textarea" value={item.commentaire !== null ? (item.commentaire):('')} disabled  placeholder="Ajoutez un commentaire" rows={3} />
                            <br/>
 
                                    

                        </Accordion.Body>
                        </Accordion.Item>
            ))}
        {props.tournoisEquipe && props.tournoisEquipe.map((item, index) => {
          const equipes = item.equipes_participantes ? item.equipes_participantes.split(', ') : [];
          const commentaires = item.commentaireEquipes ? item.commentaireEquipes.split(', ') : [];

          return (
            <Accordion.Item key={index} eventKey={`team-${index}`}>
              <Accordion.Header>
                <div>
                  <strong>{item.nomTournois} Organisé par votre équipe</strong>
                  <hr/>
                  Lieu : <strong>{item.localisation}</strong>
                  <br/>
                  Date du tournoi : <strong>{item.date}</strong>
                  <br/>
                  Nombres de participants : <strong>{item.nombre_participants} / {item.nbr_equipe} </strong>
                </div>
              </Accordion.Header>
              {item.status === 'en attente' ? (
                <Accordion.Body>
                  <div className="nom" style={{fontSize: "15px", fontWeight: 'initial'}}>
                    Il y a actuellement <strong>{item.nombre_participants}</strong> équipes qui veulent participer au tournoi de votre club.
                    <br/>
                    <strong>Liste des équipes voulant participer.</strong>
                  </div>
                  <br/>
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>Nom de l'équipe</th>
                        <th>Commentaire</th>
                      </tr>
                    </thead>
                    <tbody>
                      {equipes.map((equipe, equipeIndex) => (
                        <tr key={equipeIndex}>
                          <td>{equipe}</td>
                          <td><Form.Control as="textarea" disabled rows={2} value={commentaires[equipeIndex] !== null ? (commentaires[equipeIndex]) : ('')} /></td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  <hr/>
                  <Form.Label>Commentaire sur le tournoi</Form.Label>
                  <Form.Control as="textarea" placeholder="Ajoutez un commentaire" value={item.commentaire}  disabled rows={3} />
                </Accordion.Body>
              ) : (
                <Accordion.Body>
                  <div className="nom" style={{fontSize: "15px", fontWeight: 'initial'}}>
                    Le tournois organisé par votre équipe est<strong>{item.status}</strong>.
                  </div>
                      <div className="nom" style={{fontSize: "15px", fontWeight: 'initial'}}>
                        <strong>Liste des équipes qui participe.</strong>
                      </div>
                      <br/>
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th>Nom de l'équipe</th>
                            <th>Commentaire</th>
                          </tr>
                        </thead>
                        <tbody>
                          {equipes.map((equipe, equipeIndex) => (
                            <tr key={equipeIndex}>
                              <td>{equipe}</td>
                              <td><Form.Control as="textarea" disabled rows={2} value={commentaires[equipeIndex] !== null ? (commentaires[equipeIndex]) : ('')} /></td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                </Accordion.Body>
              )}
            </Accordion.Item>
          );
        })}

    </Accordion><br/>

    </>
  );
}

export default TournoisAffichageInscritJoueur;